import playerKo from "./locales/ko/player.json.js";
import playerEn from "./locales/en/player.json.js";
import quizKo from "./locales/ko/quiz.json.js";
import quizEn from "./locales/en/quiz.json.js";
const sharedLearningResources = {
  ko: {
    player: playerKo,
    quiz: quizKo
  },
  en: {
    player: playerEn,
    quiz: quizEn
  }
};
export {
  playerEn,
  playerKo,
  quizEn,
  quizKo,
  sharedLearningResources
};
//# sourceMappingURL=index.js.map
